import { shallowEqual } from 'react-redux';

export default shallowEqual;
